<template>
  <div class="customerInformation common_group">
    <div class="title">
      <img src="@/assets/images/userIcon.png">
      <span>客户信息</span>
    </div>
    <el-form class="common_form" label-position="left" ref="customerDataForm" :rules="rules" label-width="140px" :model="formData">
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="客户ID">
            <div class="text">{{ customerData.customerId }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="客户单位" prop="unit">
            <div class="text" v-if="!editFlage" :title="customerData.unit">{{ customerData.unit }}</div>
            <el-input v-else v-model="formData.unit" :disabled="!editPermission" maxlength="20" />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="客户姓名" prop="name">
            <div class="text" v-if="!editFlage">{{ customerData.name }}</div>
            <el-input v-else v-model="formData.name" :disabled="!editPermission" />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="联系电话" prop="phone">
            <div class="text" v-if="!editFlage">{{ customerData.phone }}</div>
            <el-input v-else v-model="formData.phone" :disabled="!editPermission" />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="邮箱">
            <div class="text" v-if="!editFlage">{{ customerData.email }}</div>
            <el-input v-else v-model="formData.email" :disabled="!editPermission" />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="职务">
            <div class="text" :title="customerData.position" v-if="!editFlage">{{ customerData.position }}</div>
            <el-input v-else v-model="formData.position" maxlength="20" :disabled="!editPermission" />
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="城市" prop="city">
            <div class="text" v-if="!editFlage">{{ customerData.city }}</div>
            <el-select
              v-else
              v-model="formData.city"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="cityLoading"
              @change="cityChange"
            >
              <el-option v-for="(item, index) in cityList" :key="index" :label="item" :value="item" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="大区">
            <div class="text" v-if="!editFlage">{{ customerData.bigArea }}</div>
            <div v-else>{{ formData.bigArea }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="区域" prop="region">
            <div class="text" v-if="!editFlage">{{ customerData.region }}</div>
            <div v-else>{{ formData.region }}</div>
            <!--            <el-select v-else v-model="formData.region" disabled @change="regionChange" placeholder="请选择">-->
            <!--              <el-option-->
            <!--                v-for="(item, index) in regionList"-->
            <!--                :key="index"-->
            <!--                :label="item"-->
            <!--                :value="item"-->
            <!--              />-->
            <!--            </el-select>-->
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="行业" prop="industry">
            <div class="text" v-if="!editFlage">{{ customerData.industry }}</div>
            <el-select v-else v-model="formData.industry" @change="industryChange" :disabled="!editPermission" clearable placeholder="请选择">
              <el-option
                v-for="(item, index) in industryList"
                :key="index"
                :label="item"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="产品线" prop="productLine">
            <commonTooltip ref-name="customerDataProductLine" v-if="!editFlage" :content="customerData.productLine" />
            <!--            <div class="text" v-if="!editFlage" :title="customerData.productLine">{{ customerData.productLine }}</div>-->
            <el-select v-else v-model="formData.productLine" :disabled="!editPermission" multiple collapse-tags clearable placeholder="请选择">
              <el-option
                v-for="item in productLineList"
                :key="item.fieldKey"
                :label="item.fieldValue"
                :value="item.fieldValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="业务单元">
            <div class="text" v-if="!editFlage">{{ customerData.businessUnit }}</div>
            <div v-else>{{ formData.businessUnit }}</div>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="客户身份" prop="identity">
            <div class="text" v-if="!editFlage">{{ customerData.identity }}</div>
            <el-select v-else v-model="formData.identity" clearable placeholder="请选择">
              <el-option
                v-for="(item, index) in identityList"
                :key="index"
                :label="item.fieldValue"
                :value="item.fieldValue"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <el-form-item label="预算金额">
            <div class="text" v-if="!editFlage">{{ customerData.budgetAmount }}</div>
            <el-input v-else v-model="formData.budgetAmount" @input="amountFileter" :disabled="!editPermission" />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <el-form-item label="备注" prop="remark">
            <div v-if="!editFlage" class="lineFeed">{{ customerData.remark }}</div>
            <el-input v-else type="textarea" v-model="formData.remark" maxlength="200" />
          </el-form-item>
        </el-col>
      </el-row>
      <!--      <el-row :gutter="50">-->
      <!--        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">-->
      <!--          <el-form-item label="页面标题">-->
      <!--            <div>新版官网栏目页项目咨询—产品线/行业线首页-售前跟进</div>-->
      <!--          </el-form-item>-->
      <!--        </el-col>-->
      <!--        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">-->
      <!--          <el-form-item label="表单ID">-->
      <!--            <div>fbdca2efb26f4fe4bb11615a1a3cbb0b</div>-->
      <!--          </el-form-item>-->
      <!--        </el-col>-->
      <!--      </el-row>-->
    </el-form>
  </div>
</template>

<script>
import { clueDetailsApi } from '../../service';
import { roleManagementApi } from '@/views/backStageManagement/service';
import { waitingProcessingApi } from '../../../privateSeaPool/service';
import commonTooltip from '@/components/commonTooltip';

export default {
  data () {
    return {
      rules: {
        region: [
          { required: true, message: '请选择所属区域', trigger: 'change' }
        ],
        city: [
          { required: true, message: '请选择所属城市', trigger: 'change' }
        ],
        industry: [
          { required: true, message: '请选择行业', trigger: 'change' }
        ],
        productLine: [
          { required: true, message: '请选择产品线', trigger: 'change' }
        ],
        unit: [
          { required: true, message: '请输入客户单位', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入客户名称', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' }
        ],
        identity: [
          { required: true, message: '请选择客户身份', trigger: 'change' }
        ],
        remark: [
          { required: true, message: '请输入备注信息', trigger: 'blur' }
        ]
      },
      formData: {},
      expensesTypeList: [],
      customerData: {},
      regionList: [],
      cityList: [],
      industryList: [],
      productLineList: [],
      identityList: [],
      editFlage: false,
      cityLoading: false
    };
  },
  props: {
    detailsData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    editPermission: {
      type: Boolean,
      default: false
    }
  },
  components: {
    commonTooltip
  },
  methods: {
    amountFileter (val) {
      let fileterVal = val.replace(/[^\d.]/g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      this.$set(this.formData, 'budgetAmount', fileterVal);
    },
    clearEditStatus () {
      this.$refs.customerDataForm.clearValidate();
    },
    remoteMethod (query) {
      if (query !== '') {
        this.cityLoading = true;
        waitingProcessingApi.getCityList(query).then(res => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              this.cityList = res.data;
            } else {
              this.cityList = [];
            }
          }
          this.cityLoading = false;
        });
      } else {
        this.cityList = [];
      }
    },
    getFormData () {
      return new Promise((resolve, reject) => {
        this.$refs['customerDataForm'].validate((valid) => {
          if (valid) {
            let params = JSON.parse(JSON.stringify(this.formData));
            params.productLine = params.productLine.join(',');
            resolve(params);
          }
        });
      });
    },
    industryChange (val) {
      if (val) {
        // this.businessUnitList = [];
        this.$set(this.formData, 'businessUnit', '');
        waitingProcessingApi.getBusinessUnitList(this.formData.city, val).then(res => {
          if (res.status === '200') {
            this.$set(this.formData, 'businessUnit', res.data[0]);
          }
        });
      }
    },
    regionChange () {
      this.$set(this.formData, 'city', '');
      this.$set(this.formData, 'industry', '');
      this.cityList = [];
      this.industryList = [];
      this.getCityList();
    },
    cityChange (val) {
      if (val) {
        // this.$set(this.formData, 'industry', '');
        // this.$set(this.formData, 'businessUnit', '');
        // this.industryList = [];
        // this.getIndustryList(val);
        // 清空业务单元
        // this.businessUnitList = [];
        this.$set(this.formData, 'businessUnit', '');
        waitingProcessingApi.getRegionArea(val).then(res => {
          if (res.status === '200') {
            this.$set(this.formData, 'bigArea', res.data.bigArea);
            this.$set(this.formData, 'region', res.data.region);
          }
        });
      }
    },
    getCityList () {
      if (this.formData.region) {
        clueDetailsApi.getCityList(this.formData.region).then(res => {
          if (res.status === '200') {
            this.cityList = res.data;
          }
        });
      }
    },
    getProductLineList () {
      roleManagementApi.getConfigureList('manage_product_line').then(res => {
        if (res.status === '200') {
          this.productLineList = res.data;
        }
      });
    },
    getIdentityList () {
      roleManagementApi.getConfigureList('客户身份').then(res => {
        if (res.status === '200') {
          this.identityList = res.data;
        }
      });
    },
    getIndustryList () {
      waitingProcessingApi.getIndustryList().then(res => {
        if (res.status === '200') {
          this.industryList = res.data;
        }
      });
    }
  },
  mounted () {
    this.customerData = JSON.parse(JSON.stringify(this.detailsData.leadCustomer));
    this.formData = JSON.parse(JSON.stringify(this.detailsData.leadCustomer));
    if (this.formData.productLine) {
      this.$set(this.formData, 'productLine', this.formData.productLine.split(','));
    }
    this.remoteMethod(this.formData.city);
    this.getProductLineList();
    this.getIndustryList();
    this.getIdentityList();
  }
};
</script>

<style lang="scss" scoped>

</style>
